import { render, staticRenderFns } from "./SquareTable.vue?vue&type=template&id=c9224e92&scoped=true&"
import script from "./SquareTable.vue?vue&type=script&lang=js&"
export * from "./SquareTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9224e92",
  null
  
)

export default component.exports